import React from 'react';
import styled from '@emotion/styled';
import AddIcon from '@atlaskit/icon/glyph/add';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import CheckIcon from '@atlaskit/icon/glyph/check';
import Button from '@atlaskit/button';

interface Props {
  name: string;
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: (name: string, status: boolean) => void;
  isSelectionFromButtonDisabled?: boolean;
}

const CTAButton = styled(Button)`
  width: 32px;
  height: 32px;
`;

export const CloudSiteItemV2 = ({
  name,
  isChecked,
  onChange,
  isDisabled = false,
  //this prop is used to disable entitlement selection through button
  isSelectionFromButtonDisabled = false,
}: Props) => {
  const _onChange = (isSelected: boolean) => {
    onChange(name, isSelected);
  };

  return (
    <div className="cloud-site-item flex justify-space-between align-center">
      <div className="cloud-site-item-name bold">{name}</div>
      {!isSelectionFromButtonDisabled && (
        <>
          <div className="cloud-site-item-v2-selection">
            {isChecked ? (
              <CTAButton
                testId={`cloud-site-item-selected-cta-btn-${name}`}
                className="cloud-site-item-selected-cta-btn cta-btn"
                onClick={() => _onChange(false)}
                isDisabled={isDisabled}
                iconBefore={
                  <>
                    {/* based on class name cloud-site-select-cta-btn is hiding and displaying */}
                    <span className="cloud-site-select-cta-btn">
                      <CheckIcon label="Selected cloud site" size="large" />
                    </span>
                    {/* based on class name cloud-site-cancel-cta-btn is hiding and displaying */}
                    <span className="cloud-site-cancel-cta-btn">
                      <CrossIcon label="Remove cloud site" size="small" />
                    </span>
                  </>
                }
              />
            ) : (
              <CTAButton
                testId={`cloud-site-item-add-cta-btn-${name}`}
                className="cloud-site-item-add-cta-btn cta-btn"
                onClick={() => _onChange(true)}
                isDisabled={isDisabled}
                iconBefore={<AddIcon label="Add cloud site" size="small" />}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};
